



























import { AccessToggleIdentifier } from '~/models/user/access-toggles'
import CUserAccessToggles from '~/components/shared/configurable/access-toggle/CUserAccessToggles.vue'
import {
  defineComponent,
  onBeforeUnmount,
  PropType,
  ref,
  watch
} from '@nuxtjs/composition-api'
import { vue3Model } from '~/utils/nuxt3-migration'

export default defineComponent({
  model: vue3Model,
  components: {
    CUserAccessToggles
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
      required: true
    },
    identifier: {
      type: [String, Number] as PropType<AccessToggleIdentifier>,
      required: true
    },
    userDisplayName: {
      type: String,
      default: null
    }
  },
  setup(props, { emit }) {
    const visible = ref(props.modelValue)

    watch(
      () => props.modelValue,
      newValue => {
        visible.value = newValue
      }
    )
    watch(visible, value => {
      emit('update:modelValue', value)
    })

    onBeforeUnmount(() => {
      emit('close')
    })

    return {
      visible
    }
  }
})
